import { useState, useEffect } from 'react';
import {
  Navigate,
  Outlet,
  useLocation,
  useSearchParams,
} from 'react-router-dom';
import { useAuth } from './hooks/useAuth';
import Button from '@material-ui/core/Button';

export const ProtectedRoutes = () => {
  const { token, logout } = useAuth();
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const [isTokenValid, setIsTokenValid] = useState('');
  const redirectUrl = location.pathname + location.search;
  const searchOrgId = searchParams.get('organization');
  const pathOrgId = location.pathname.split('/')[1];
  const orgId = searchOrgId || pathOrgId;

  const handleLogout = () => {
    logout();
  };

  useEffect(() => {
    const url = `https://eu-api.empathicbuilding.com/v1/organizations/${orgId}`;
    const requestOptions = {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const validateToken = async () => {
      const response = await fetch(url, requestOptions);
      if (response.status === 200) {
        setIsTokenValid(true);
      } else {
        setIsTokenValid(false);
      }
    };
    token && validateToken();
  }, [orgId, token]);

  if (isTokenValid === true) {
    return (
      <div>
        <Button
          variant="outlined"
          style={{
            position: 'absolute',
            top: '0.5rem',
            right: '0.5rem',
          }}
          onClick={handleLogout}
        >
          Logout
        </Button>
        <Outlet />
      </div>
    );
  }

  if (isTokenValid === false || token === null) {
    return <Navigate to="/login" state={redirectUrl} />;
  }

  return <div>Loading...</div>;
};
